<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px" :hide-required-asterisk="true">
        <div>
          <el-form-item label="是否全部专业及级别进行调整" label-width="200px" prop="isAllUpdate" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-radio-group v-model="form.isAllUpdate">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.isAllUpdate">
            <div style="color: red;">
              对未进行申请、审核未通过和审核通过的专业同步调整
            </div>
            <div style="font-weight: bold;">
              全部专业
              <i class="icon icon_arrow-down-filling"></i>
            </div>
            <div v-for="(item,index) in specialtyList" :key="index" class="inline-block" style="margin-right: 10px;margin-top: 10px;">{{item.specialtyName}}</div>
          </div>
          <div v-else style="font-weight: bold;">
            {{this.form.categoryName}} {{this.form.specialtyName}}
          </div>
          <el-form-item label-width="120px" label="报名时间" prop="enrollTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 20px;">
            <el-date-picker v-model="form.enrollTime" type="datetimerange" @change="changeDate(form)" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="{disabledDate:disabledDate1}" format="yyyy-MM-dd HH:mm" :default-time="['00:00:00','23:59:00']"></el-date-picker>
          </el-form-item>
          <el-form-item label-width="120px" label="考试时间" prop="examTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.examTime" type="datetimerange" @change="changeDate(form)" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="{disabledDate:disabledDate2}" format="yyyy-MM-dd HH:mm" :default-time="['00:00:00','23:59:00']"></el-date-picker>
          </el-form-item>
          <el-form-item v-if="needAdmissionOpenTime == 1" label-width="120px" label="准考证开放时间" prop="admissionOpenTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.admissionOpenTime" type="datetime" @change="changeDate(form)" :picker-options="{disabledDate:disabledDate3}" format="yyyy-MM-dd HH:mm"
                            placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">提交申请</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      specialtyList: [],
      needAdmissionOpenTime: this.row.needAdmissionOpenTime
    }
  },
  async created () {
    await this.initForm(this.row)
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    disabledDate1 (curr) {
      return this.$moment(curr).isBefore(this.$moment(this.row.enrollStartTime).add(0, 'day')) || this.$moment(curr).isAfter(this.$moment(this.row.enrollEndTime).add(0, 'day'))
    },
    disabledDate2 (curr) {
      return this.$moment(curr).isBefore(this.$moment(this.row.examStartTime).add(0, 'day')) || this.$moment(curr).isAfter(this.$moment(this.row.examEndTime).add(0, 'day'))
    },
    disabledDate3 (curr) {
      return this.$moment(curr).isBefore(this.$moment(this.row.enrollStartTime).add(0, 'day')) || this.$moment(curr).isAfter(this.$moment(this.row.examStartTime).add(0, 'day'))
    },
    async initForm (row) {
      if (!this.Tool.isNull(row)) {
        let info = JSON.parse(JSON.stringify(row))
        this.specialtyList = await this.$HTTP.ApiTimeAudit.getListSpecialty({ batchId: info.batchId })
        if (info.enrollStartTime && info.enrollEndTime) {
          info.enrollTime = [this.$moment(info.enrollStartTime), this.$moment(info.enrollEndTime)]
        }
        if (info.examStartTime && info.examEndTime) {
          info.examTime = [this.$moment(info.examStartTime), this.$moment(info.examEndTime)]
        }
        info = this.changeDate(info)
        info.isAllUpdate = 0
        this.form = info
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    changeDate (info) {
      if (info.enrollTime) {
        info.enrollStartTime = info.enrollTime[0]
        info.enrollEndTime = info.enrollTime[1]
      }
      if (info.examTime) {
        info.examStartTime = info.examTime[0]
        info.examEndTime = info.examTime[1]
      }
      return info
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let confirm = await this.$confirm('请确保时间填写无误，提交申请后可在审核管理中查看', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let info
          let data = {
            batchId: this.form.batchId,
            isAllUpdate: this.form.isAllUpdate,
            specialtyId: this.form.specialtyId,
            enrollStartTime: this.form.enrollTime[0],
            enrollEndTime: this.form.enrollTime[1],
            examStartTime: this.form.examTime[0],
            examEndTime: this.form.examTime[1],
            admissionOpenTime: this.$moment(this.form.admissionOpenTime)
          }
          if (this.$moment(this.form.examStartTime).isSameOrAfter(this.$moment(this.form.enrollStartTime)) && this.$moment(this.form.examEndTime).isSameOrAfter(this.$moment(this.form.enrollEndTime))) {
            if (this.form.specialtyId) {
              info = await this.$HTTP.ApiTimeAudit.add(data)
              this.$message({ type: 'success', message: '操作成功' })
            }
            this.$emit('close', info)
          } else {
            throw new Error('考试开始时间必须大于等于报名开始时间，且考试结束时间必须大于等于报名结束时间')
          }
        }
      }
    }
  }
}
</script>
<style>
  .el-form-item__label {
    text-align: left;
  }
</style>
